import React from 'react'
import styled from 'styled-components'
import defaultFilterOptions from '../data/filters.json'

const filterOptions = {
  ...defaultFilterOptions, 
  priorCollegeState: defaultFilterOptions['highSchoolState'],
  priorCollegeCounty: defaultFilterOptions['highSchoolCounty'],
  alabama: [
    { code: 'true', label: 'In-State' },
    { code: 'false', label: 'Out-of-State' },
  ]
}

const filterTitles = {
  alabama: 'Residency',
  sex: 'Sex',
  raceEthnicity: 'Race/Ethnicity',
  college: 'College',
  highSchoolState: 'High School State or Province',
  priorCollegeState: 'Prior College State',
  distanceLearning: 'Program type',
}

const toName = key => 
  filterTitles[key] || 
  key
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, function(str) {
      return str.toUpperCase()
    })

const toLabel = (key, value) => 
  (filterOptions && filterOptions[key].find(i => i.code===value))
    ? filterOptions[key].find(i => i.code===value).label
    : value

const Wrapper = styled.div`
  display: none;
  span:not(:first-child):before {
    content: ' | '
  }
  @media print {
    display: block !important;
  }
`

const component = ({ filters, residency }) => (
  <Wrapper>
    <h4 style={{ fontWeight: 'normal' }}>
      {Object.keys(filters)
        .filter(key => filters[key]===true || filters[key].length > 0)
        .map((key, index) =>
          <span key={key}>
            <b>{toName(key)}</b>:&nbsp;
            {toLabel(key, filters[key])}
          </span>
        )
      }
    </h4>
  </Wrapper>
)

export default component
